import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { WebSocket } from 'isows';
import { HttpRequestError, TimeoutError, WebSocketRequestError } from '../errors/request.js';
import { createBatchScheduler } from './promise/createBatchScheduler.js';
import { withTimeout } from './promise/withTimeout.js';
import { stringify } from './stringify.js';
let id = 0;
async function http(url, _ref) {
  let {
    body,
    fetchOptions = {},
    timeout = 10000
  } = _ref;
  const {
    headers,
    method,
    signal: signal_
  } = fetchOptions;
  try {
    var _response$headers$get;
    const response = await withTimeout(async _ref2 => {
      var _body$id2;
      let {
        signal
      } = _ref2;
      const response = await fetch(url, _objectSpread(_objectSpread({}, fetchOptions), {}, {
        body: Array.isArray(body) ? stringify(body.map(body => {
          var _body$id;
          return _objectSpread({
            jsonrpc: '2.0',
            id: (_body$id = body.id) !== null && _body$id !== void 0 ? _body$id : id++
          }, body);
        })) : stringify(_objectSpread({
          jsonrpc: '2.0',
          id: (_body$id2 = body.id) !== null && _body$id2 !== void 0 ? _body$id2 : id++
        }, body)),
        headers: _objectSpread(_objectSpread({}, headers), {}, {
          'Content-Type': 'application/json'
        }),
        method: method || 'POST',
        signal: signal_ || (timeout > 0 ? signal : undefined)
      }));
      return response;
    }, {
      errorInstance: new TimeoutError({
        body,
        url
      }),
      timeout,
      signal: true
    });
    let data;
    if ((_response$headers$get = response.headers.get('Content-Type')) !== null && _response$headers$get !== void 0 && _response$headers$get.startsWith('application/json')) {
      data = await response.json();
    } else {
      data = await response.text();
    }
    if (!response.ok) {
      throw new HttpRequestError({
        body,
        details: stringify(data.error) || response.statusText,
        headers: response.headers,
        status: response.status,
        url
      });
    }
    return data;
  } catch (err) {
    if (err instanceof HttpRequestError) throw err;
    if (err instanceof TimeoutError) throw err;
    throw new HttpRequestError({
      body,
      details: err.message,
      url
    });
  }
}
export const socketsCache = /*#__PURE__*/new Map();
export async function getSocket(url) {
  let socket = socketsCache.get(url);
  // If the socket already exists, return it.
  if (socket) return socket;
  const {
    schedule
  } = createBatchScheduler({
    id: url,
    fn: async () => {
      const webSocket = new WebSocket(url);
      // Set up a cache for incoming "synchronous" requests.
      const requests = new Map();
      // Set up a cache for subscriptions (eth_subscribe).
      const subscriptions = new Map();
      const onMessage = _ref3 => {
        let {
          data
        } = _ref3;
        const message = JSON.parse(data);
        const isSubscription = message.method === 'eth_subscription';
        const id = isSubscription ? message.params.subscription : message.id;
        const cache = isSubscription ? subscriptions : requests;
        const callback = cache.get(id);
        if (callback) callback({
          data
        });
        if (!isSubscription) cache.delete(id);
      };
      const onClose = () => {
        socketsCache.delete(url);
        webSocket.removeEventListener('close', onClose);
        webSocket.removeEventListener('message', onMessage);
      };
      // Setup event listeners for RPC & subscription responses.
      webSocket.addEventListener('close', onClose);
      webSocket.addEventListener('message', onMessage);
      // Wait for the socket to open.
      if (webSocket.readyState === WebSocket.CONNECTING) {
        await new Promise((resolve, reject) => {
          if (!webSocket) return;
          webSocket.onopen = resolve;
          webSocket.onerror = reject;
        });
      }
      // Create a new socket instance.
      socket = Object.assign(webSocket, {
        requests,
        subscriptions
      });
      socketsCache.set(url, socket);
      return [socket];
    }
  });
  const [_, [socket_]] = await schedule();
  return socket_;
}
function webSocket(socket, _ref4) {
  let {
    body,
    onResponse
  } = _ref4;
  if (socket.readyState === socket.CLOSED || socket.readyState === socket.CLOSING) throw new WebSocketRequestError({
    body,
    url: socket.url,
    details: 'Socket is closed.'
  });
  const id_ = id++;
  const callback = _ref5 => {
    let {
      data
    } = _ref5;
    const message = JSON.parse(data);
    if (typeof message.id === 'number' && id_ !== message.id) return;
    onResponse === null || onResponse === void 0 || onResponse(message);
    // If we are subscribing to a topic, we want to set up a listener for incoming
    // messages.
    if (body.method === 'eth_subscribe' && typeof message.result === 'string') {
      socket.subscriptions.set(message.result, callback);
    }
    // If we are unsubscribing from a topic, we want to remove the listener.
    if (body.method === 'eth_unsubscribe') {
      var _body$params;
      socket.subscriptions.delete((_body$params = body.params) === null || _body$params === void 0 ? void 0 : _body$params[0]);
    }
  };
  socket.requests.set(id_, callback);
  socket.send(JSON.stringify(_objectSpread(_objectSpread({
    jsonrpc: '2.0'
  }, body), {}, {
    id: id_
  })));
  return socket;
}
async function webSocketAsync(socket, _ref6) {
  let {
    body,
    timeout = 10000
  } = _ref6;
  return withTimeout(() => new Promise(onResponse => rpc.webSocket(socket, {
    body,
    onResponse
  })), {
    errorInstance: new TimeoutError({
      body,
      url: socket.url
    }),
    timeout
  });
}
///////////////////////////////////////////////////
export const rpc = {
  http,
  webSocket,
  webSocketAsync
};
//# sourceMappingURL=rpc.js.map